import { h, Fragment } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";
import { Box, Button, Grid, Paper, Stack, Tooltip, Typography } from "@mui/material";

import PersonIcon from "@mui/icons-material/Person";

import MyLocationIcon from "@mui/icons-material/MyLocation";
import DescriptionIcon from "@mui/icons-material/Description";

import EventsTimeLineCard from "../Common/EventsTimeLineCard";
import PersonnalCard from "../Common/PersonnalCard";

import { redThreadUser } from "../Common/redthread";

import { AppContext } from "../../AppContext";

import palette from "../../theme/palette";
export default function DashboardNotaire(props) {

	const [state, setState] = useState({ ctx: undefined });

	const app = useContext(AppContext);

	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/0c42e370c0604bd2888d0168cc85cb67", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState((state) => ({
							...state,
							ctx: res.pld,
						}));

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);
	const acceptDealAsNotary = (uid) => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/452c0648ce8448fcbd0eaa71cf3a93ed/" + uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						goToDeal(uid);

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	const declineDealAsNotary = (uid) => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/008ba3658df34a1fadd97dd4d952c846/" + uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.reload();

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};

	useEffect(() => {
		//sconsole.log(state);
		redThreadUser(state, app, "notaire");
	}, [state]);
	const goToDeal = (u) => {
		window.location.href = "/508f2de0fa994052a6d0cbc0c3b4d8c7/" + u;
	};

	//console.log("render", state);
	if (state.ctx === undefined) {
		return false;
	}

	return (

		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Paper style="padding: 10px ">
					<Grid container alignItems="center">
						<Grid item xs={6}>
							<Typography variant="h5">Bienvenue dans votre espace notaire</Typography>
						</Grid>
						<Grid item xs>
							<Box display="flex" justifyContent="flex-end" alignItems="center" flexDirection="row">
								<Box></Box>
							</Box>
						</Grid>
					</Grid>
				</Paper>
			</Grid>
			<Grid item xs={12} sm={6}>
				<PersonnalCard user={state.ctx} />
				<Paper style="padding: 10px; margin-bottom: 10px;">
					<Typography variant="h5" style="width: 100%; border-bottom: 1px solid rgb(234, 234, 234);">Vos dossiers</Typography>

					{state.ctx &&
						state.ctx.deals &&
						state.ctx.deals.map((dl) => {
							return (
								<Paper key={dl.u} style="padding: 10px; margin-bottom: 10px; margin-top: 10px; background-color:  #f7f7f7b3;">
									<Grid container spacing={1}>
										<Grid
											item
											xs={12}
											md={6}
											style="cursor: pointer;"
											onClick={() => {
												if (dl.acc === true) {
													goToDeal(dl.u);
												} else {
													app.refPopUp.current.handleChangeState(
														{
															opened: true,
															type: "002",
															params: {
																title: "Attention",
																body: (
																	<div>
																		<Typography variant="body1" gutterBottom>
																			Vous devez accepter la mission avant de pouvoir consulter ce dossier de vente
																		</Typography>
																	</div>
																),
																yes_action: () => {
																	declineDealAsNotary(dl.u);
																}
															}
														})

												}
											}}
										>
											{false && (
												<Box display="flex" justifyContent="flex-start" alignItems="center">
													<Box>
														<DescriptionIcon style="margin-right: 10px;" />
													</Box>
													<Box>
														<Typography variant="h5">
															{dl.d != undefined ? dl.d : <em>Pas de nom enregistré</em>}
														</Typography>
													</Box>
												</Box>
											)}
											<Box display="flex" justifyContent="space-between" alignItems="space-between">
												<Box>
													<Box display="flex" justifyContent="flex-end" alignItems="center">
														<Box>
															<PersonIcon style="margin-right: 10px;" />
														</Box>
														<Box>
															{dl.role === "VN" && (
																<Typography variant="body1">
																	{dl.v !== undefined ? dl.v : <em>Pas de vendeur enregistré</em>}
																</Typography>
															)}
															{dl.role === "AC" && (
																<Typography variant="body1">
																	{dl.s !== undefined ? dl.s : <em>Pas d'acquéreur enregistré</em>}
																</Typography>
															)}
														</Box>
													</Box>
												</Box>
											</Box>
											<Box display="flex" justifyContent="flex-start" alignItems="center">
												<Box>
													<MyLocationIcon style="margin-right: 10px;" />
												</Box>
												<Box>
													<Typography variant="body1">
														{dl.mn != undefined ? dl.mn : <em>Pas d'adresse enregistrée</em>}
													</Typography>
												</Box>
											</Box>
										</Grid>
										{dl.acc === null && (
											<Grid item xs={12} md={6}>
												<Paper style={{ padding: "10px", backgroundColor: palette.orangeAlert }}>
													<Stack spacing={1} alignItems="center">
														<Typography variant="h5" gutterBottom>
															Acceptation de la mission
														</Typography>
														<Box display="flex" justifyContent="space-between" style="width: 100%">
															<Box>
																<Button
																	onClick={() => {
																		app.refPopUp.current.handleChangeState(
																			{
																				opened: true,
																				type: "002",
																				params: {
																					title: "Attention",
																					body: (
																						<div>
																							<Typography variant="h5" gutterBottom>
																								Voulez vous vraiment refuser cette mission?
																							</Typography>
																						</div>
																					),
																					yes_action: () => {
																						declineDealAsNotary(dl.u);
																					}
																				}
																			})

																	}}
																>
																	Refuser
																</Button>
															</Box>
															<Box>
																<Button variant="contained" onClick={() => acceptDealAsNotary(dl.u)}>
																	Accepter
																</Button>
															</Box>
														</Box>
													</Stack>
												</Paper>
											</Grid>
										)}
										{dl.acc === false && (
											<Grid item xs={12} md={6}>
												<Paper style={{ padding: "10px", backgroundColor: palette.redAlert }}>
													<Typography variant="h5" gutterBottom>
														Vous avez refusé d'assister cette vente immobilière
													</Typography>
												</Paper>
											</Grid>
										)}
										{dl.acc === true && (
											<Grid item xs={12} md={6}>
												<Paper style={{ padding: "10px", backgroundColor: palette.greenAlert }}>
													<Typography variant="h5" gutterBottom>
														Vous avez accepté d'assister cette vente immobilière
													</Typography>
												</Paper>
											</Grid>
										)}
									</Grid>
								</Paper>
							);
						})}

					{state.ctx && state.ctx.deals && state.ctx.deals.length === 0 && (
						<Box
							display="flex"
							alignItems="center"
							justifyContent="center"
							flexDirection="column"
							p={1}
							m={1}

						>
							<Box p={1}>
								<Typography variant="h5">Vous n'avez pas encore de dossier de vente</Typography>
							</Box>
							<Box p={1}></Box>
							<Box p={1}></Box>
						</Box>
					)}
				</Paper>
			</Grid>
			<Grid item xs={12} sm={6}>
				<EventsTimeLineCard events={state.ctx.events} />
			</Grid>
		</Grid>

	);
}
